
// Import all vendor packages.
require('jquery');
require('bootstrap');
require('font-awesome-webpack');
require('fullcalendar');
require('summernote');
require('eonasdan-bootstrap-datetimepicker');



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/vendor.ts